import { dashboardAuthenticate } from '@anghami/neogateway/dist/endpoints/authentication';
import { gateway } from 'helpers/gateway-helper';

export const verifyMfaOtp = (mfaToken: string, otp: string) => {
  return gateway.callEndpoint(dashboardAuthenticate, {
    koussa_it_mfa_token: mfaToken,
    koussa_it_otp: otp,
    appsid: '',
    sid: ''
  });
};
